import type { ButtonIcon } from "commons/styles/ComponentsType";
import i18n from "i18n";

export interface INavigatesVO {
  id: LEFT | SEC;
  name: string;
  router: string;
  role: number;
  nation?: number;
  key?: string;
  match?: string;
  disabled?: boolean;
  isActive?: boolean;
  icon?: string | ButtonIcon;
}

export enum ROLE {
  MASTER = 1, //패스트뷰 관리자
  ADMIN = 2, //사용자(회사 계정)
  USER = 4, //사용자(회사에 속해있는 사원 계정)
}

export enum NATION {
  KO = 1, //국내
  EN = 2, //해외
}

/**
 * 리뉴얼 후 new 메뉴
 */
export enum NAV_TOP {
  ALARM = "alarm",
  CHAT = "chat",
  NOTICE = "notice",
  SETTING = "setting",
}

/**
 * 리뉴얼 후 new 메뉴
 */
export enum LEFT {
  PROVIDER = "provider", //콘텍스트
  MEDIA = "media", // 미디어
  PARTNERS = "partners", // 파트너스
  TRANSLATE = "translate", //번역
  CALCULATE = "calculate", // 정산
  HELP = "help", //도움말
  HELP_EN = "help_en", //해외-도움말
}

export enum SEC {
  HOME = "home", //홈
  CHANNEL_SET = "channel_setting", //채널 관리
  REVENUE = "revenue", // 수익

  MEDIA_LIST = "media_list", // 음원목록

  TRANSLATE_LIST = "translate_list", // 번역 > 소재 리스트
  TRANSLATE_MANAGE = "translate_manage", // 번역 > 작업관리
  TRANSLATE_FAIL = "translate_fail", // 번역 > 번역 실패
}

/**
 * 리뉴얼 전 메뉴
 */
// export enum LEFT {
//   REPORT = "report",
//   MY = "my",
//   NOTICE = "notice",
//   MANAGE = "manage",
//   USERMANAGE = "usermanage",
//   USERINFO = "userinfo",
//   CALCULATE = "calculate", //정산

//   STATISTICS = "statistics", //통계
//   PROFIT = "profit", //수익
//   USER = "user", //ver2 사용자
//   SERVICE = "service", //서비스

//   TRANSLATE = "translate", //번역
// }

// export enum SEC {
//   CONTENT = "content",
//   LIST = "list",
//   VIDEO = "video",
//   VIEWUS = "viewus",
// }

const RoleList = [
  ROLE.MASTER,
  ROLE.ADMIN,
  ROLE.USER,
  ROLE.MASTER + ROLE.ADMIN,
  ROLE.MASTER + ROLE.USER,
  ROLE.ADMIN + ROLE.USER,
  ROLE.MASTER + ROLE.ADMIN + ROLE.USER,
];

const languageList = [NATION.KO, NATION.EN, NATION.KO + NATION.EN];

export function getRouter(id: LEFT | SEC | string): string;
export function getRouter(top: LEFT, left: SEC): string;
export function getRouter(a: LEFT | SEC | string, sec?: SEC): string {
  let vo: INavigatesVO | undefined;
  if (sec) {
    vo = getRouteVo(a as LEFT, sec);
  } else {
    vo = getRouteVo(a);
  }
  if (vo !== undefined) {
    return vo.router;
  }
  return "/";
}

export function getRouteVo(id: LEFT | SEC | string): INavigatesVO | undefined;
export function getRouteVo(left: LEFT, sec: SEC): INavigatesVO | undefined;
export function getRouteVo(a: LEFT | string, sec?: SEC): INavigatesVO | undefined {
  const itemAr = sec === undefined ? a.split(".") : [a, sec];
  const item = leftList.filter(item => item.id === itemAr[0]);
  if (item.length > 0) {
    if (itemAr.length > 1) {
      const sub = secList[item[0].id].filter(item => item.id === itemAr[1]);
      if (sub.length > 0) {
        return sub[0];
      } else {
        return item[0];
      }
    } else {
      return item[0];
    }
  } else {
    //
  }
  return;
}

export const leftList: Array<INavigatesVO> = [
  {
    name: i18n.t("nav.GNB.provider"),
    id: LEFT.PROVIDER,
    role: RoleList[6],
    nation: languageList[0],
    router: "/admin/provider",
  },
  {
    name: i18n.t("nav.GNB.media"),
    id: LEFT.MEDIA,
    role: RoleList[6],
    nation: languageList[2],
    router: "/admin/media",
  },
  {
    name: i18n.t("nav.GNB.partners"),
    id: LEFT.PARTNERS,
    role: RoleList[6],
    nation: languageList[0],
    router: "/admin/partners",
  },
  {
    name: i18n.t("nav.GNB.translation"),
    id: LEFT.TRANSLATE,
    role: RoleList[6],
    nation: languageList[2],
    router: "/admin/translate/list",
  },
  {
    name: i18n.t("nav.GNB.settlement"),
    id: LEFT.CALCULATE,
    role: RoleList[0],
    nation: languageList[2],
    router: "/admin/calculate/provider",
  },
  {
    name: i18n.t("nav.GNB.help"),
    id: LEFT.HELP,
    role: RoleList[6],
    nation: languageList[2],
    router: i18n.language !== "en" ? "/admin/help/provider" : "/admin/help/media",
  },
];

export const secList: { [key: string]: Array<INavigatesVO> } = {
  [LEFT.PROVIDER]: [
    {
      name: i18n.t("nav.LNB.home"),
      id: SEC.HOME,
      role: RoleList[6],
      router: "/admin/provider",
    },
    {
      name: i18n.t("nav.LNB.channelSetting"),
      id: SEC.CHANNEL_SET,
      role: RoleList[6],
      router: "/admin/provider/setting",
    },
    {
      name: i18n.t("nav.LNB.revenue"),
      id: SEC.REVENUE,
      role: RoleList[3],
      router: "/admin/provider/revenue",
    },
  ],

  [LEFT.MEDIA]: [
    {
      name: i18n.t("nav.LNB.home"),
      id: SEC.HOME,
      role: RoleList[6],
      router: "/admin/media",
    },
    {
      name: i18n.t("nav.LNB.mediaList"),
      id: SEC.MEDIA_LIST,
      role: RoleList[6],
      router: "/admin/media/list",
    },
    {
      name: i18n.t("nav.LNB.channelSetting"),
      id: SEC.CHANNEL_SET,
      role: RoleList[6],
      router: "/admin/media/setting",
    },
    {
      name: i18n.t("nav.LNB.revenue"),
      id: SEC.REVENUE,
      role: RoleList[3],
      router: "/admin/media/revenue",
    },
  ],
  [LEFT.PARTNERS]: [
    {
      name: i18n.t("nav.LNB.home"),
      id: SEC.HOME,
      role: RoleList[6],
      router: "/admin/partners",
    },

    {
      name: i18n.t("nav.LNB.revenue"),
      id: SEC.REVENUE,
      role: RoleList[3],
      router: "/admin/partners/revenue",
    },
  ],

  [LEFT.TRANSLATE]: [
    {
      name: i18n.t("nav.LNB.translation.list"),
      id: SEC.TRANSLATE_LIST,
      role: RoleList[6],
      router: "/admin/translate/list",
    },
    {
      name: i18n.t("nav.LNB.translation.manage"),
      id: SEC.TRANSLATE_MANAGE,
      role: RoleList[6],
      router: "/admin/translate/manage",
    },
    {
      name: i18n.t("nav.LNB.translation.fail"),
      id: SEC.TRANSLATE_FAIL,
      role: RoleList[3],
      router: "/admin/translate/fail",
    },
  ],

  [LEFT.CALCULATE]: [
    {
      name: i18n.t("nav.GNB.provider"),
      id: LEFT.PROVIDER,
      role: RoleList[0],
      router: "/admin/calculate/provider",
    },
    {
      name: i18n.t("nav.GNB.media"),
      id: LEFT.MEDIA,
      role: RoleList[0],
      router: "/admin/calculate/media",
    },
    {
      name: i18n.t("nav.GNB.partners"),
      id: LEFT.PARTNERS,
      role: RoleList[0],
      router: "/admin/calculate/partners",
    },
  ],

  [LEFT.HELP]: [
    {
      name: i18n.t("nav.GNB.provider"),
      id: LEFT.PROVIDER,
      role: RoleList[6],
      nation: languageList[0],
      router: "/admin/help/provider",
    },
    {
      name: i18n.t("nav.GNB.media"),
      id: LEFT.MEDIA,
      role: RoleList[6],
      nation: languageList[2],
      router: "/admin/help/media",
    },
  ],
};

// export const leftList: Array<INavigatesVO> = [
//   {
//     name: "통계",
//     id: LEFT.STATISTICS,
//     role: RoleList[6],
//     router: "/admin/statistics",
//   },
//   {
//     name: "수익",
//     id: LEFT.PROFIT,
//     role: RoleList[6],
//     router: "/admin/profit",
//   },

//   {
//     name: "정산",
//     id: LEFT.CALCULATE,
//     role: RoleList[0],
//     router: "/admin/calculate",
//   },
//   {
//     name: "서비스",
//     id: LEFT.SERVICE,
//     role: RoleList[6],
//     router: "/admin/service",
//   },
//   {
//     name: "번역",
//     id: LEFT.TRANSLATE,
//     role: RoleList[6],
//     router: "/admin/translate",
//   },

//   //관리자에게 보여질 메뉴
//   {
//     name: "사용자 관리",
//     id: LEFT.USERMANAGE,
//     role: RoleList[0],
//     router: "/admin/usermanage/viewus",
//   },
//   {
//     name: "사용자",
//     id: LEFT.USER,
//     role: RoleList[0],
//     router: "/admin/user",
//   },
//   //제휴사에게 보여줄 메뉴
//   {
//     name: "프로필",
//     id: LEFT.USERINFO,
//     role: RoleList[5],
//     router: "/admin/userinfo/info",
//   },
//   {
//     name: "공지사항",
//     id: LEFT.NOTICE,
//     role: RoleList[6],
//     router: "/admin/notice",
//   },
// ];

// export const secList: { [key: string]: Array<INavigatesVO> } = {
//   [LEFT.USERMANAGE]: [
//     {
//       name: "콘텐츠",
//       id: LEFT.USERMANAGE,
//       role: RoleList[5],
//       router: "/admin/usermanage/viewus",
//     },
//     {
//       name: "음원/영상",
//       id: LEFT.USERMANAGE,
//       role: RoleList[5],
//       router: "/admin/usermanage/video",
//     },
//   ],
// };
